import React, { Component } from 'react';
import { FormGroup, Label, Input, FormText } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import InputFeedback from 'components/InputFeedback';

class InputGroupInfo extends Component {
  render() {
    const {
      label,
      placeholder,
      helpText,
      type,
      link,
      linkRoutes,
      classInput,
      errorClass,
      value,
      staticDomain,
      error,
      onChange,
      id,
      linkOnClick,
      priceValue,
      priceText,
      showPremium,
      plan,
      ...props
    } = this.props;
    return (
      <FormGroup className={errorClass}>
        <div className="form-group__top">
          {label && (
            <Label for={id} className="form-group__label">
              {label}
            </Label>
          )}
          {helpText && <FormText color="muted-grey">{helpText}</FormText>}
          {link && (
            <Link to={linkRoutes} onClick={linkOnClick} color="muted-grey">
              {link}
            </Link>
          )}
        </div>
        <div className="form-group__inner">
          {staticDomain && (
            <span className="form-group-static_domain">instalinks.com/</span>
          )}
          <Input
            type={type}
            id={id}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            {...props}
          />
          {showPremium && (
            <div className="form-group__pricevalue">
              {plan === 'monthly' ? '$3' : '$30'}
              <span>{plan === 'monthly' ? '/MO' : '/year'}</span>
            </div>
          )}
        </div>
        <InputFeedback error={error} />
      </FormGroup>
    );
  }
}

export default InputGroupInfo;



// WEBPACK FOOTER //
// ./src/components/InputGroupInfo/InputGroupInfo.js